// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._143zsbglAzWBR4 {\n  background-color: #A5ADBA;\n  border-radius: 4px;\n  color: #FFFFFF;\n  display: block;\n  margin-right: 4px;\n  max-width: 100%;\n  overflow: hidden;\n  padding: 3px 6px;\n  position: relative;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n._2rs-S4XaR7PGqD {\n  background-color: #61BD4F;\n}\n._2lg2kelVQVxwKN {\n  background-color: #F2D600;\n}\n._2dP2aNootmBUEI {\n  background-color: #FF9F1A;\n}\n._1chvZ1UWxRXC90 {\n  background-color: #EB5A46;\n}\n._3ae58Z_P_aosTo {\n  background-color: #C377E0;\n}\n._3eXXJ8iI42WJrD {\n  background-color: #0079BF;\n}\n._33J71UzncECjsf {\n  background-color: #FF78CB;\n}\n._3X_rf7HrlXQ59W {\n  background-color: #00C2E0;\n}\n._2zlQCzLi7PLC98 {\n  background-color: #51E898;\n}\n._2UHTyR3Xm2zcAx {\n  background-color: #4d4d4d;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardLabel": "_143zsbglAzWBR4",
	"green": "_2rs-S4XaR7PGqD",
	"yellow": "_2lg2kelVQVxwKN",
	"orange": "_2dP2aNootmBUEI",
	"red": "_1chvZ1UWxRXC90",
	"purple": "_3ae58Z_P_aosTo",
	"blue": "_3eXXJ8iI42WJrD",
	"pink": "_33J71UzncECjsf",
	"sky": "_3X_rf7HrlXQ59W",
	"lime": "_2zlQCzLi7PLC98",
	"black": "_2UHTyR3Xm2zcAx"
};
export default ___CSS_LOADER_EXPORT___;
